<template>
  <div
    v-if="loaded"
    class="tableContainer tableContainerCustom marginTop15"
    style="border-radius: 5px"
  >
    <f7-row>
      <f7-col>
        <DxForm
          style="padding: 5px"
          class="ha-form marginTop15"
          col-count="1"
          :form-data="formData"
        >
          <!-- Finca -->
          <DxItem
            :editor-options="{
              items: formData.farms,
              onValueChanged: farmChanged,
              value: isEditingFarm ? farmStr : farm,
              width: '180px',
              valueExpr: isEditingFarm ? 'farm' : 'id',
              displayExpr: 'name',
              disabled: isEditingFarm,
              placeholder: $t('select'),
            }"
            data-field=""
            editor-type="dxSelectBox"
            css-class="required-star-out narrow-field separated-input"
          >
            <DxRequiredRule :message="$t('alert.requiredFarm')" />
            <DxLabel :text="$t('agronomySample.summary.estate')" />
          </DxItem>

          <!-- Responsable -->
          <DxItem
            css-class="required-star-out narrow-field separated-input"
            :editor-options="{
              onValueChanged: accountableChanged,
              value: accountable,
              width: '180px',
              disabled: isEditingFarm,
              placeholder: $t('select'),
            }"
            data-field=""
            editor-type="dxTextBox"
          >
            <DxRequiredRule :message="$t('accountableRequired')" />
            <DxLabel :text="$t('accountable')" />
          </DxItem>

          <!-- Lat/Lon/Surface entre finca y responsable -->
          <DxItem item-type="simple" name="geoData">
            <template #default>
              <div class="geo-data-block-form">
                <span class="geo-label">{{ $t('latitude') }}:</span>
                <strong class="geo-value">{{
                  centroide ? centroide.lat.toFixed(6) : ''
                }}</strong>

                <span class="geo-label">{{ $t('longitude') }}:</span>
                <strong class="geo-value">{{
                  centroide ? centroide.lng.toFixed(6) : ''
                }}</strong>

                <span class="geo-label">
                  {{ $t('surface') }} (ha):
                </span>
                <strong class="geo-value">{{
                  area ? area.toFixed(2) : ''
                }}</strong>
              </div>
            </template>
          </DxItem>
        </DxForm>
      </f7-col>
    </f7-row>
    <!-- <f7-row>
      <f7-col>
        <DxForm
          style="padding: 5px"
          class="ha-form marginTop15"
          col-count="1"
          :form-data="formData"
        >
          <DxItem
            :editor-options="{
              items: formData.farms,
              onValueChanged: farmChanged,
              value: isEditingFarm ? farmStr : farm,
              width: '235px',
              valueExpr: isEditingFarm ? 'farm' : 'id',
              displayExpr: 'name',
              disabled: isEditingFarm,
              placeholder: $t('select'),
            }"
            data-field=""
            editor-type="dxSelectBox"
          >
            <DxRequiredRule :message="$t('alert.requiredFarm')" />
            <DxLabel :text="$t('agronomySample.summary.estate')" />
          </DxItem>

          <DxItem
            :editor-options="{
              onValueChanged: accountableChanged,
              value: accountable,
              width: '235px',
              disabled: isEditingFarm,
              placeholder: $t('select'),
            }"
            data-field=""
            editor-type="dxTextBox"
          >
            <DxRequiredRule :message="$t('accountableRequired')" />
            <DxLabel :text="$t('accountable')" />
          </DxItem>
        </DxForm>
      </f7-col>
      <f7-col></f7-col>
      <f7-col></f7-col>
      <f7-col></f7-col>
      <f7-col style="margin-top: 15px">
        <span>
          {{ $t('latitude') }}:
          <strong>{{
            centroide ? centroide.lat.toFixed(6) : ''
          }}</strong>
        </span>
        <br />

        <span style="margin-top: 25px">
          {{ $t('longitude') }}:
          <strong>{{
            centroide ? centroide.lng.toFixed(6) : ''
          }}</strong>
        </span>
        <br />

        <span>
          {{ $t('surface') }} (ha):
          <strong>{{ area ? area.toFixed(2) : '' }}</strong>
        </span>
      </f7-col>
    </f7-row> -->
  </div>
</template>

<script>
import { DxForm, DxItem, DxLabel } from 'devextreme-vue/form';
import { DxRequiredRule } from 'devextreme-vue/validator';
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';

export default {
  components: {
    DxForm,
    DxItem,
    DxLabel,
    DxRequiredRule,
  },
  data() {
    return {
      formData: {
        farms: [],
      },
      loaded: false,
    };
  },
  computed: {
    ...mapState('registerFarm', [
      'farm',
      'farmStr',
      'accountable',
      'reset',
      'isEditingFarm',
    ]),
    ...mapState('gisEditor', ['area', 'centroide']),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    if (this.reset) {
      this.setFarm('');
      this.setAccountable('');
    }

    if (!this.isEditingFarm) {
      try {
        this.formData.farms = await this.getFarms(true);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(error.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    } else {
      this.formData.farms.push({ farm: this.farmStr });
    }

    this.$f7.preloader.hide();
    this.loaded = true;
  },
  methods: {
    farmChanged(e) {
      if (!e.event) return;
      this.setFarmStr(e.event.target.innerText);
      this.setFarm(e.value);
    },
    accountableChanged(e) {
      if (!e.event) return;
      this.setAccountable(e.value);
    },
    ...mapActions('gis', ['getFarms']),
    ...mapActions('registerFarm', [
      'setFarm',
      'setAccountable',
      'setFarmStr',
    ]),
  },
};
</script>
<style>
.geo-data-block-form {
  display: grid;
  grid-template-columns: 120px auto;
  row-gap: 6px;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 10px;
  padding-left: 2px;
}

.geo-label {
  color: var(--Neutral-50, #8a8693);
  font-weight: 700;
  text-align: left;
}

.geo-value {
  font-weight: 700;
  color: #00346a;
}

/* 1) Oculta el asterisco que DevExtreme coloca (el que se te mete en el input) */
.required-star-out .dx-field-item-required-mark {
  display: none !important;
}

/* 2) Añade nuestro asterisco junto al texto del label, fuera del input */
.required-star-out .dx-field-item-label-text::after {
  content: ' *';
  color: #a80d0b; /* o el color que uses */
  font-weight: 700;
  margin-left: 4px;
}

.separated-input .dx-field-item-content {
  margin-left: 15px; /* ajusta este valor según lo que necesites */
}

.tableContainerCustom {
  background: #f7f7f8 !important;
}
</style>
